import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import TextField from "@mui/material/TextField";
import {
    add_chat_message,
    clear_chat_error,
    get_chat_history,
    reset_chat,
    submit_chat_message
} from "../../actions/chat";
import BouncingDotsLoader from "./BouncingDotsLoader";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import {refresh_ai_availability} from "../../actions/auth";
import {Tooltip} from "@mui/material";


const styles = (theme) => ({
    chatWrapper: {
        position: "fixed",
        bottom: 0,
        right: 100,
        zIndex: 1060,
        maxHeight: "calc(100vh - 80px)",
        [theme.breakpoints.down('sm')]: {
            right: 0,
            left: 0,
            width: "100%",
            maxHeight: "calc(100vh - 40px)"
        }
    },
    chatHeader: {
        backgroundColor: "#00ff00",
        color: "black",
        lineHeight: "26px",
        boxSizing: "border-box",
        height: 40,
        display: "flex",
        cursor: "pointer",
        justifyContent: "space-between"
    },
    chatHeaderClosed: {
        width: 240,
        padding: "7px 15px",
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        border: 0,
        textAlign: "left",
        cursor: "pointer",
        [theme.breakpoints.down('sm')]: {
            width: 140,
        }
    },
    chatHeaderOpened: {
        width: 580,
        padding: "7px 15px",
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        border: 0,
        textAlign: "left",
        [theme.breakpoints.down('md')]: {
            width: "380px",
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        }
    },
    chatHeaderRightIcons: {
        "& button": {
            color: "black",
        }
    },
    chatContent: {
        width: 580 - 2,
        height: 550,
        backgroundColor: "#2d2d2d",
        [theme.breakpoints.down('md')]: {
            width: 380 - 2,
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
        borderLeft: "1px solid rgba(81, 81, 81, 1)",
        borderRight: "1px solid rgba(81, 81, 81, 1)"
    },
    chatContentMessages: {
        height: 550 - 120 - 1 - 15,
        maxHeight: "60vh",
        //borderBottom: "1px solid black",
        overflowY: "auto",
        paddingTop: 15,
        //background: "black"
    },
    chatContentMessagesMessageWrapper: {
        display: "flex",
    },
    chatContentMessagesMessage: {
        maxWidth: "80%",
        display: "inline-block",
        margin: 15,
        marginTop: 0,
        padding: "8px 15px",
        borderRadius: 4,
    },
    chatContentMessagesMessageUser: {
        marginLeft: "auto",
        background: "#000"
    },
    chatContentMessagesMessageAssistant: {
        marginRight: "auto",
        color: "#000000",
        backgroundColor: "#00ff00"
    },
    chatContentMessagesMessageError: {
        backgroundColor: "#f44336"
    },
    chatContentMessagesMessageAssistantWriting: {
        marginRight: "auto",
        /*color: "#000000",
        backgroundColor: "#00ff00"*/
    },
    chatContentInput: {
        height: 120,
        //background: "black",
        borderTop: "1px solid rgba(81, 81, 81, 1)"
    }
});

class AIChat extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: localStorage.getItem("chat_opened") === "yes",
            message: ""
        };
        this.shiftMod = false;
        this.messagesDiv = React.createRef();
        this.textInput = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.chat.history.length !== prevProps.chat.history.length) {
            this.scrollChatToBottom();
            this.props.refresh_ai_availability();
        }
    }

    componentDidMount() {
        this.props.refresh_ai_availability();
        this.props.get_chat_history().then(this.scrollChatToBottom.bind(this));
        if (this.state.open) {
            this.focusTextInput();
        }
    }

    scrollChatToBottom() {
        if (this.messagesDiv.current) {
            this.messagesDiv.current.scrollTo(0, this.messagesDiv.current.scrollHeight);
        }
    }

    toggleOpen() {
        this.props.refresh_ai_availability();
        const new_state = !this.state.open
        this.setState({
            ...this.state,
            open: new_state
        }, () => {
            localStorage.setItem("chat_opened", new_state ? "yes" : "no");
            if (new_state) {
                this.scrollChatToBottom();
                this.focusTextInput();
            }
        });
    }

    focusTextInput() {
        if (this.messagesDiv.current) {
            this.textInput.current.focus()
        }
    }

    headerClicked(e) {
        const name = e.target.nodeName.toLocaleLowerCase();
        if (name !== "svg" && name !== "path" && name !== "button") {
            this.toggleOpen();
        }
    }

    submitMessage() {
        const prev_error = this.props.chat.error !== null;
        this.props.clear_chat_error();
        const old_message = this.state.message;
        this.setState({
            ...this.state,
            message: ""
        });
        this.props.add_chat_message("user", old_message);
        this.scrollChatToBottom.bind(this);

        const {history} = this.props.chat;
        if (history.length === 0 || history[history.length - 1].role === "assistant" || prev_error) {
            this.props.submit_chat_message(old_message)
                .then(this.scrollChatToBottom.bind(this));
        }

        /*.catch(e => {
            // return message if error occured
            this.setState({
                ...this.state,
                message: old_message
            });
        })*/
        ;
    }

    resetChat() {
        this.setState({
            ...this.state,
            message: ""
        });
        this.props.reset_chat();
    }

    keyDown(event) {
        const code = event.keyCode || event.charCode
        if (code === 16) { // shift
            this.shiftMod = true;
        }
    }

    keyUp(event) {
        const code = event.keyCode || event.charCode
        if (code === 16) { // shift
            this.shiftMod = false;
        } else if (code === 13) { // enter
            if (!this.shiftMod) {
                this.submitMessage();
            }
        }
    }

    render() {
        const {classes} = this.props;
        const header = (<div
            className={clsx(classes.chatHeader, this.state.open ? classes.chatHeaderOpened : classes.chatHeaderClosed)}
            onClick={(e) => this.headerClicked(e)}
        >
            <Typography component="span">Question prompt</Typography>
            {this.state.open && <div className={classes.chatHeaderRightIcons}>
                {this.props.auth.user.ai_available && <IconButton size="small" onClick={this.resetChat.bind(this)}>
                    <DeleteIcon fontSize="inherit"/>
                </IconButton>}
                <IconButton size="small" onClick={this.toggleOpen.bind(this)}>
                    <CloseIcon fontSize="inherit"/>
                </IconButton>
            </div>}
        </div>);
        return <div className={classes.chatWrapper}>
            {!this.state.open && <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                                          PopperProps={{
                                              style: {maxWidth: "70vw"}
                                          }}
                                          title={<Typography>Ask A. I. Teacher</Typography>}
                                          placement="top" interactive>
                {header}
            </Tooltip>}
            {this.state.open && <>
                {header}
            </>}
            {this.state.open && <div className={classes.chatContent}>
                <div className={classes.chatContentMessages} ref={this.messagesDiv} style={{
                    background: this.props.theming.darkMode ? "black" : "white"
                }}>
                    {!this.props.auth.user.ai_available && <div
                        className={classes.chatContentMessagesMessageWrapper}>
                        <div
                            className={clsx(
                                classes.chatContentMessagesMessage,
                                classes.chatContentMessagesMessageAssistant
                            )}
                        >
                            <Typography component="p">
                                Upgrade to <span
                                style={{fontWeight: 900, cursor: "pointer"}}
                                onClick={() => {
                                    this.props.history.push('/premium')
                                }}>PREMIUM</span> to ask A. I. Teacher!
                            </Typography>
                        </div>
                    </div>}


                    {this.props.auth.user.ai_available && this.props.chat.history.map((message, i) => <div
                        className={classes.chatContentMessagesMessageWrapper}
                        key={"message-" + i}>
                        <div
                            className={clsx(
                                classes.chatContentMessagesMessage,
                                message.role === "user" ? classes.chatContentMessagesMessageUser : classes.chatContentMessagesMessageAssistant
                            )}
                        >
                            <Typography component="p">{message.content}</Typography>
                        </div>
                    </div>)}
                    {this.props.chat.history.length > 0 && this.props.chat.history[this.props.chat.history.length - 1].role === "user" && !this.props.chat.error &&
                        <div
                            className={clsx(
                                classes.chatContentMessagesMessage,
                                classes.chatContentMessagesMessageAssistantWriting
                            )}
                        >
                            <div style={{display: "flex", alignItems: "flex-end"}}>
                                <Typography component="p">
                                    Working on it
                                </Typography>
                                <BouncingDotsLoader color="white"/>
                            </div>
                        </div>}
                    {this.props.chat.error && <div className={classes.chatContentMessagesMessageWrapper}>
                        <div
                            className={clsx(
                                classes.chatContentMessagesMessage,
                                classes.chatContentMessagesMessageAssistant,
                                classes.chatContentMessagesMessageError
                            )}
                        >
                            <Typography component="p">{this.props.chat.error}</Typography>
                        </div>
                    </div>}
                </div>
                <div className={classes.chatContentInput} style={{
                    background: this.props.theming.darkMode ? "black" : "white"
                }}>
                    <TextField
                        multiline
                        inputRef={this.textInput}
                        disabled={!this.props.auth.user.ai_available}
                        value={this.state.message}
                        onChange={(e) => this.setState({...this.state, message: e.target.value})}
                        style={{
                            /*                            height: "calc(100% - 30px)",
                                                        width: "calc(100% - 30px)",
                                                        margin: 15*/
                            height: "100%",
                            width: "100%"
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '100%',
                                borderRadius: 0,
                            },
                            '& .MuiInputBase-input': {
                                height: '100% !important',
                            },
                            '& fieldset': {
                                border: '0 !important',
                            }
                        }}
                        onKeyDown={this.keyDown.bind(this)}
                        onKeyUp={this.keyUp.bind(this)}
                    />
                </div>
            </div>}
        </div>
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    chat: state.chat,
    theming: state.theming
});
export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {get_chat_history, submit_chat_message, add_chat_message, reset_chat, refresh_ai_availability, clear_chat_error}
)(AIChat)));
